module.exports = ".pic-small {\n  max-width: 128px;\n  max-height: 128px;\n  min-width: 64px;\n  min-height: 64px; }\n  .pic-small img {\n    max-height: 128px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/slideshow/slideshow.widget.scss
// module id = ./src/app/views/presentations/widgets/slideshow/slideshow.widget.scss
// module chunks = main